var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1731",
    "data-name": "Grupo 1731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1072",
    "data-name": "Caminho 1072",
    fill: "#EFEFF2",
    d: "M14.5,3l4.44,4.44-.15.16L8.37,18a.6.6,0,0,1-.25.16l-6,1.66H2.09c0-.08,0-.16.05-.23l1.6-5.74a.58.58,0,0,1,.18-.3Q9.13,8.29,14.36,3.08ZM5.1,16.79l1.84-.5a.8.8,0,0,0,.32-.19l5.79-5.78.13-.15L11.73,8.69l-.05,0L5.74,14.68a.36.36,0,0,0-.11.16c-.17.63-.34,1.27-.53,1.95Zm8.17-9.65,1.47,1.5L15.9,7.38,14.51,6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessEdit);
export default __webpack_public_path__ + "static/media/access-edit.2946ef7cf966b5e101a4507fe507ba1e.svg";
export { ForwardRef as ReactComponent };